import * as React from "react"
import { cn } from "../../lib/utils"
import { Button } from "./button"

/**
 * EmptyState — estado vacío unificado
 * @param {React.ReactNode} icon
 * @param {string} title
 * @param {string} [description]
 * @param {Object} [action]       — { label, onClick } o { label, href }
 * @param {string} [className]
 */
export function EmptyState({ icon, title, description, action, className }) {
  return (
    <div className={cn("flex flex-col items-center justify-center py-16 px-6 text-center", className)}>
      {icon && (
        <div className="p-4 rounded-full bg-[#007D6E]/8 mb-4">
          <div className="text-[#007D6E] [&_svg]:h-8 [&_svg]:w-8">
            {icon}
          </div>
        </div>
      )}
      <h3 className="text-base font-semibold text-foreground mb-1">{title}</h3>
      {description && (
        <p className="text-sm text-muted-foreground max-w-xs mb-5">{description}</p>
      )}
      {action && (
        action.href ? (
          <Button asChild size="sm">
            <a href={action.href}>{action.label}</a>
          </Button>
        ) : (
          <Button size="sm" onClick={action.onClick}>
            {action.label}
          </Button>
        )
      )}
    </div>
  )
}

export default EmptyState
